import { useContext, useState, useEffect } from "react";
import React from 'react';
import {  useLoaderData, redirect } from 'react-router-dom';

import { getOrdersPending, getLabConfig } from '../utils/api';
import PendingOrderItem from '../components/Order/PendingOrderItem';

import MenuContext from '../store/MenuContext';
import TestInfoClasses from '../components/Tests/TestInfo.module.css';

const OrderHistory = (props) => {
	const OrderHistory=useLoaderData();
	const menuTheme = useContext(MenuContext);

		const [PPURL, setPPURL] = useState([]);
		useEffect(() => {
			async function fetchPortalTitle() {
				let PPURL2="http://localhost:3001";
				if (process.env.NODE_ENV === 'production') {
					 PPURL2 = await getLabConfig("PPWEBSERVER");
				}
				console.log(PPURL2);
				setPPURL(PPURL2);
			}
			fetchPortalTitle();
		}, []);
		const [webURL, setWebURL] = useState([]);
		useEffect(() => {
			async function fetchLabSetting() {
				const webURL = await getLabConfig('WEBSERVER');
				setWebURL(webURL);
			}
			fetchLabSetting();
		}, [])
    return( 
    		<div className={TestInfoClasses.testInfo}>
	    	<div className={TestInfoClasses.testInfoContent}>
	    		<h2 className={TestInfoClasses.testTitle} >Order History</h2>
	    		
			<table className={TestInfoClasses.inboxReport}>
				<thead><tr><th>Ordered Date</th><th>Test(s) Ordered</th><th/><th>Order Number</th><th>Status</th></tr></thead>
				<tbody>
				{console.log("PPURL",PPURL)}
			{OrderHistory === 'no pending orders' ? (
				  <p>No data available.</p>
				) : (
				  OrderHistory.map((item) => {
					  return (
						<PendingOrderItem
						  key={item.disReqNum}
						  item={{
							name: item.displaycodes,
							disReqNum: item.disReqNum,
							orderDT: item.DateOrdered,
							releasedRaw: item.Released,
							reqNumber: item.ReqNumber,
							pending: item.Pending,
							reqTests: item?.ReqTestsID,
							destlab: item.lab,
							status: item.Status,
							PPURL: PPURL,
							webURL: webURL
						  }}
						/>
					  );
					})
			)}

			</tbody></table>
		</div>
	</div>
	);
};

export default OrderHistory;

export async function loader() {
    const response = await getOrdersPending();
	const resData = await response;
		if (resData.length) {
			console.log(resData);
			return resData;
		}else{
			return redirect('/Login');
		}
}

